import { MSG_VARIANT_MAP } from "./bettoAlertConfig";
import { BETTO_ALERT_VARIANTS } from "./bettoAlertVariants";

export { isTooManyLoginAttemptsError, resolveLoginErrorVariant } from "./bettoAuthErrors";

const VERIFICATION_ERROR_PATTERNS = [
	"verification",
	"verify code",
	"verification code",
	"verification_link_broken",
];

const WITHDRAW_SUCCESS_PATTERNS = ["withdraw", "withdrawal"];

const matchesPattern = (value, patterns) => {
	if (!value || typeof value !== "string") {
		return false;
	}

	const normalized = value.toLowerCase();
	return patterns.some((pattern) => normalized.includes(pattern));
};

const resolveByMessage = (alertData) => {
	const msg = alertData?.msg;

	if (!msg || typeof msg !== "string") {
		return null;
	}

	if (MSG_VARIANT_MAP[msg]) {
		return MSG_VARIANT_MAP[msg];
	}

	if (matchesPattern(msg, VERIFICATION_ERROR_PATTERNS)) {
		return alertData.type === "success" ? "verification-complete" : "invalid-verification-code";
	}

	if (alertData.type === "success" && matchesPattern(msg, WITHDRAW_SUCCESS_PATTERNS)) {
		return "request-submitted";
	}

	return null;
};

const resolveByType = (alertData) => {
	if (alertData?.isConfirm) {
		return "something-went-wrong";
	}

	if (alertData?.type === "error") {
		return "something-went-wrong";
	}

	return null;
};

export const resolveBettoAlertVariantKey = (alertData) => {
	if (alertData?.bettoVariant && BETTO_ALERT_VARIANTS[alertData.bettoVariant]) {
		return alertData.bettoVariant;
	}

	return resolveByMessage(alertData) || resolveByType(alertData);
};

export const resolveBettoAlert = (alertData) => {
	const variantKey = resolveBettoAlertVariantKey(alertData);
	const variant = BETTO_ALERT_VARIANTS[variantKey];

	if (!variant) {
		return null;
	}

	let buttons = [...variant.buttons];

	if (alertData?.isConfirm) {
		buttons = [
			{
				variant: "primary",
				labelKey: "betto.header.yes",
				action: "accept",
			},
			{
				variant: "secondary",
				labelKey: "betto.header.no",
				action: "close",
			},
		];
	} else if (alertData?.actionLabel) {
		buttons = [
			{
				variant: "primary",
				labelKey: alertData.actionLabel,
				action: "customAction",
				fullWidth: true,
			},
		];
	}

	return {
		variantKey,
		illustrationKey: variant.illustrationKey || variantKey,
		...variant,
		buttons,
	};
};
